export default {"src":"/_next/static/media/BX.16ee1937.svg","height":18,"width":18};